import React, { useEffect, useRef, useState } from 'react';
import { IBAN_REGEX } from '../../../../utils/constants';
import { insertSpaceEveryNChars } from '../../../../utils/stringUtils';
import ValidationTip from '../../../validationtip/Validationtip';

interface InputFieldIBANProps {
  id?: string;
  label?: string;
  name?: string;
  classes?: string;
  required?: boolean;
  maxlength?: number;
  onChangeHandler: (value: string) => void;
  onBlurHandler: (value: string) => void;
  value?: string;
  resetValue?: string;
  readonly?: boolean;
  tooltip?: string;
}

const InputFieldIBAN = ({
  id,
  label,
  name,
  classes = '',
  required = false,
  maxlength,
  onChangeHandler,
  onBlurHandler,
  value,
  resetValue = '',
  readonly = false,
  tooltip = '',
}: InputFieldIBANProps) => {
  const [selectionStart, setSelectionStart] = useState<number | null>(0);
  const [valueShown, setValueShown] = useState<string | undefined>(value);
  const [key, setKey] = useState<string>('');

  const input = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (value === '' || value === undefined) onChangeHandler(resetValue);
  }, [value]);

  useEffect(() => {
    if (value && input.current && selectionStart !== null) {
      if (
        !['Backspace', 'Delete'].includes(key) &&
        value.length !== 1 &&
        value.length % 4 === 1
      ) {
        input.current.selectionStart = selectionStart + 1;
        input.current.selectionEnd = selectionStart + 1;
      } else {
        input.current.selectionStart = selectionStart;
        input.current.selectionEnd = selectionStart;
      }
    }
  }, [valueShown]);

  useEffect(() => {
    if (value !== undefined) setValueShown(insertSpaceEveryNChars(value, 4));
  }, [value]);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = event.target.value;
    let newCursorPosition = event.target.selectionStart;
    if (key === 'Backspace') {
      if (
        event.target.selectionStart &&
        newValue.split(' ').find(el => el.length > 4)
      ) {
        // Leerzeichen wurde gelöscht
        newValue =
          newValue.substring(0, event.target.selectionStart - 1) +
          newValue.substring(event.target.selectionStart, newValue.length);
        newCursorPosition = event.target.selectionStart - 1;
      }
      // letzter Char vor Space gelöscht
      else if (
        event.target.selectionStart &&
        event.target.selectionStart + 1 == newValue.length &&
        event.target.selectionStart % 5 == 0
      ) {
        newCursorPosition = event.target.selectionStart - 1;
      }
    } else if (key === 'Delete') {
      if (
        event.target.selectionStart &&
        newValue.split(' ').find(el => el.length > 4)
      ) {
        // Leerzeichen wurde gelöscht
        newValue =
          newValue.substring(0, event.target.selectionStart) +
          newValue.substring(event.target.selectionStart + 1, newValue.length);
      } else if (
        event.target.selectionStart &&
        event.target.selectionStart == newValue.length &&
        event.target.selectionStart % 5 == 0
      ) {
        newCursorPosition = event.target.selectionStart - 1;
      }
    }
    setSelectionStart(newCursorPosition);
    onChangeHandler(newValue.replaceAll(' ', ''));
  };

  const onKeyDown = (event: React.KeyboardEvent) => {
    setKey(event.key);
  };

  const onBlur = () => {
    value && onBlurHandler(value);
  };

  const onFocusHandler = () => {
    return;
  };

  return (
    <div className={`floating form-group ${classes}`} onBlur={onBlur}>
      <ValidationTip fieldName={name ?? ''}>
        <input
          title={tooltip}
          id={id}
          placeholder=' '
          required={required}
          maxLength={maxlength}
          value={valueShown ?? ''}
          ref={input}
          onChange={event => onChange(event)}
          onKeyDown={e => onKeyDown(e)}
          onFocus={() => onFocusHandler()}
          readOnly={readonly}
          pattern={IBAN_REGEX}
        />
        <label className='floating-label'>{label}</label>
      </ValidationTip>
    </div>
  );
};

export default InputFieldIBAN;
